import React, { Component } from 'react';
import './ContactusIcon.css';
const getType = type => {
  switch (type) {
    case 'email':
      return 'email-2';
    case 'sms':
      return 'chat-1';
    default:
      return type;
  }
};

const fillOrLineal = props => (props.hasOwnProperty('fill') ? 'fill' : 'lineal');

export default class ContactusIcon extends Component {
  render = () => (
    <i
      className={`flaticon-contactus-${fillOrLineal(this.props)}-${getType(this.props.type)} ${this.props.className || ''} ${this.props.highlight ? 'highlight' : ''}`}
      onClick={this.props.onClick}
      style={this.props.style}
    />
  );
}
